<template>
    <div>
        <div :class="{ 'd-none': displayNone }">
            <div v-if="step == 1">
                <client-identify></client-identify>
            </div>
            <div v-if="step == 2">
                <new-client></new-client>
            </div>
            <div v-if="step == 3">
                <client-card></client-card>
            </div>
            <div v-if="step == 4">
                <choose-services></choose-services>
            </div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex'

export default {
  // todo rename to just "order" because newOrder is only one of feat
    name: "NewOrder",
    components: {
        clientIdentify: () => import('../components/order/ClientIdentify.vue'),
        newClient: () => import('../components/order/NewClient.vue'),
        clientCard: () => import('../components/order/ClientCard.vue'),
        chooseServices: () => import('../components/order/ChooseServices/ChooseServices.vue'),
    },
    data() {
        return {
            orderId: '',
          orderInfo: null,
        }
    },
    created() {
        if(this.$route.params.orderId === 'new') {
            this.orderId = ''
        } else {
            this.orderId = this.$route.params.orderId
        }
    },
    computed: {
      ...mapGetters([
        "step",
        "displayNone",
        "orderLoaded",
      ]),
      ...mapGetters("shift", [
        "shiftData",
      ]),
    },
    async mounted() {
        if(this.orderId) {
            this.loadOrderData()
        } else {
            this.$store.commit('resetChoosenServicesComponent')
            this.$store.commit('goToStep', 1)
        }
        this.$store.dispatch('fetchKKMStatus')
    },
    methods: {
        loadOrderData() {
            console.log('hit load order data')
            this.$store.dispatch('shift/fetchShiftData')
            this.$store.dispatch('fetchOrder', { 'order_id': this.orderId }).then(()=>{
              this.$store.commit('goToStep', 4)
            })
        }
    }
}
</script>

<style>
    .notify {
    position: fixed;
    right: 5px;
    top: 5px;
    z-index: 999999;
    }

    .notify > div {
        padding: 10px 15px;
        border-radius: 3px;
        margin-bottom: 5px;
        font-size: 14px;
    }

    .notify > div.success {
        background: #28a745;
    }

    .notify > div.error {
        background: #dc3545;
    }

    .notify > div.warning {
        background: #ffc107;
        color: #000;
    }

    .notify > div.info {
        background: #17a2b8;
        color: #000;
    }

    .bubble {
        position: relative;
        max-width: 30em;
        background-color: #fff;
        padding: 1.125em 1.5em;
        margin: 0em 0.5em;
        font-size: 0.9em;
        border-radius: 1rem;
        box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, .3), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);
    }

    .bubble-top::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        bottom: 100%;
        left: 1.5em;
        border: .75rem solid transparent;
        border-top: none;
        border-bottom-color: #fff;
        filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, .1));
    }

    .bubble-bottom::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        top: 100%;
        left: 5.5em;
        border: .75rem solid transparent;
        border-bottom: none;
        border-top-color: #fff;
        filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, .1));
    }

    .btn-success.disabled, .btn-success:disabled {
        color: #fff;
        background-color: #77d7a0 !important;
        border-color: #77d7a0 !important;
    }
</style>
